import { __decorate, __metadata } from "tslib";
// NPM
import { Component, Prop, Mixins } from "vue-property-decorator";
// SYSTEM1
import Loader from "@/components/widgets/loader.vue";
import BaseMixer from "@/router/views/BaseMixer";
import simplebar from "simplebar-vue";
import { PAReviewModule } from "@/store/modules/paReview.module";
import { IPAReviewItemDetailDTO } from "@/store/models/paReview/paReviewItemDetailDTO";
import SetupReviewMeeting from "./SetupReviewMeeting.vue";
import ReviewMeetingDetail from "./ReviewMeetingDetail.vue";
import paReviewMeetingMachine from "../machines/reviewMeetingMachine";
import { interpret } from "xstate/lib/interpreter";
let ReviewMeeting = /** @class */ (() => {
    var _a;
    let ReviewMeeting = class ReviewMeeting extends Mixins(BaseMixer) {
        constructor() {
            super(...arguments);
            this.loading = false;
            this.machine = paReviewMeetingMachine;
            this.machineService = interpret(this.machine, { devTools: true });
            this.state = this.machine.initialState;
            this.previousState = this.machine.initialState;
        }
        ShowSetupReviewMeeting() {
            this.mode = "Add";
            this.machineService.send({
                type: "SCHEDULE_MEETING",
            });
        }
        send(event) {
            this.machineService.send(event);
        }
        Initialize() {
            this.machineService.send({
                type: "GETTING_REVIEW_MEETING",
                reviewId: this.reviewDetails.reviewCycleId,
            });
        }
        notify() {
            this.loading = true;
            this.machineService.send({
                type: "NOTIFY_DETAIL_COMPONENT",
            });
        }
        resetReview(reviewId) {
            this.machineService.send({
                type: "INITIALIZE",
                reviewId: reviewId,
            });
        }
        editMeeting(meetingId) {
            this.mode = "Edit";
            this.machineService.send({
                type: "EDIT_MEETING",
                meetingId: meetingId,
            });
        }
        cancel(mode) {
            if (mode == "Edit") {
                this.machineService.send({
                    type: "NOTIFY_DETAIL_COMPONENT",
                });
            }
            else {
                this.machineService.send({
                    type: "CANCEL",
                });
            }
        }
        stopLoading() {
            this.loading = false;
        }
        get isGoogleCalendarSynced() {
            return PAReviewModule.isGoogleCalendarSynced;
        }
        get tittle() {
            if (this.state.matches("loadedReviewMeeting.startMeeting") && this.previousState.matches("loadedReviewMeeting.scheduleReviewMeeting")) {
                return "Schedule Review Meeting";
            }
            else if (this.state.matches("loadedReviewMeeting.startMeeting") && this.previousState.matches("loadedReviewMeeting.reviewMeetingDetails")) {
                return "Edit Review Meeting";
            }
            else {
                return "Review Meeting";
            }
        }
        created() {
            this.Initialize();
            this.machineService.start();
            this.machineService.onTransition((state) => {
                this.previousState = this.state;
                this.state = state;
            });
        }
        destroyed() {
            this.machineService.stop();
        }
    };
    __decorate([
        Prop(),
        __metadata("design:type", typeof (_a = typeof IPAReviewItemDetailDTO !== "undefined" && IPAReviewItemDetailDTO) === "function" ? _a : Object)
    ], ReviewMeeting.prototype, "reviewDetails", void 0);
    ReviewMeeting = __decorate([
        Component({
            name: "ReviewMeeting",
            components: {
                Loader,
                simplebar,
                SetupReviewMeeting,
                ReviewMeetingDetail,
            },
        })
    ], ReviewMeeting);
    return ReviewMeeting;
})();
export default ReviewMeeting;
